import React, { useEffect, useContext, useCallback } from 'react';
import { observer } from 'mobx-react';
import Styles from './index.module.scss';
import { DocsStore } from '../../models';
import { DocType } from '@/pages/document/Types';
import DefaultDocView from '@/component/DocView/DocType/DefaultView';

function DocContent() {
  const docsInfoStore = useContext(DocsStore);
  const {
    activeDocId, viewType, docConfig,
    docContent, docContentStatus,
  } = docsInfoStore;

  useEffect(() => {
    if (activeDocId && viewType) {
      // if (viewType === 'SINGLE') {
      docsInfoStore.getDocContent(activeDocId);
      // }
    }
  }, [activeDocId, viewType]);

  const hashChange = useCallback((hash) => {
    docsInfoStore.activeHash = hash;
    // 子Iframe 向父级传递变化信息
    window.parent.postMessage({ origin: 'doc_change', hash }, '*');
  }, []);

  // const globalChange = useCallback((docId) => {
  //   if (!docsInfoStore.isClickNav) {
  //     docsInfoStore.activeDocId = docId;
  //   }
  // }, []);

  return (
    <div className={Styles.container}>
      {/* {viewType === 'GLOBAL'
        ? (
          <GlobalDocView
            list={docsInfoStore.globalDocContent}
            onChange={globalChange}
          />
        ) : (
          <DefaultDocView
            title={docContent.title}
            content={docContent.content}
            type={docContent.type as DocType}
            status={docContentStatus}
            config={docConfig}
            hashChange={hashChange}
          />
        )} */}
      <DefaultDocView
        title={docContent.title}
        content={docContent.content}
        type={docContent.type as DocType}
        status={docContentStatus}
        config={docConfig}
        hashChange={hashChange}
      />
    </div>
  );
}

export default React.memo(observer(DocContent));
